import { Controller } from "@hotwired/stimulus";

// GO4SANALYTICS "En direct": reloads its turbo-frame every `interval` ms,
// only while the tab is visible (a hidden tab costs the server nothing).
export default class extends Controller {
  static values = { interval: { type: Number, default: 15000 }, url: String };

  connect() {
    this.timer = setInterval(() => this.refresh(), this.intervalValue);
    this.onVisible = () => {
      if (document.visibilityState === "visible") this.refresh();
    };
    document.addEventListener("visibilitychange", this.onVisible);
  }

  disconnect() {
    clearInterval(this.timer);
    document.removeEventListener("visibilitychange", this.onVisible);
  }

  refresh() {
    if (document.visibilityState !== "visible") return;
    if (!this.element.src) this.element.src = this.urlValue;
    else if (typeof this.element.reload === "function") this.element.reload();
  }
}
